import Vue from 'vue'

import { registerComponent } from '../app'
import CartService from '../services/Cart'
import { CART_UPDATED, CART_LOADING, CART_LOADING_FINISH } from '../events'
import { money } from '../helpers/format'

const Cart = (scope, el) => {
	const app = new Vue({
		el: el,
		data: {
			items: CartService.data.items,
			itemCount: CartService.data.item_count,
			loading: CartService.loading,
			subtotal: CartService.data.items_subtotal_price
		},
		methods: {
			sizedImage: (url, width) => {
				let parts = url.split('.')
				return parts.reduce((acc, val, index) => {
					return index == parts.length - 1
						? acc + '_' + width + 'x' + width + '.' + val
						: acc + '.' + val
				})
			},
			compareAtPrice: item => {
				return item.properties._compare_at_price || item.compare_at_price
			},
			price: value => {
				return money(value)
			},
			changeQuantity: (id, quantity) => {
				CartService.changeQuantity(id, quantity)
			},
			cartEmpty: function() {
				return this.items === undefined || this.items.length < 1
			}
		},
		delimiters: ['<%', '%>']
	})

	scope.on(CART_LOADING, () => {
		app.loading = true
	})
	scope.on(CART_LOADING_FINISH, () => {
		app.loading = false
	})
	scope.on(CART_UPDATED, data => {
		app.items = data.items
		app.itemCount = data.item_count
		app.subtotal = data.items_subtotal_price
	})

	scope.init(() => CartService.get())
}

registerComponent('cart', Cart)
